/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournament_Wiz_Kind_Parallel_DescInputs */



/**
* | output |
* | --- |
* | "All rounds run at once and each player plays them side by side, as on async platforms." |
*
* @param {Tournament_Wiz_Kind_Parallel_DescInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournament_wiz_kind_parallel_desc = /** @type {((inputs?: Tournament_Wiz_Kind_Parallel_DescInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournament_Wiz_Kind_Parallel_DescInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Toutes les rondes ont lieu en même temps et chaque joueur les joue en parallèle, comme sur les plateformes asynchrones.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Todas las rondas se juegan a la vez y cada jugador las juega en paralelo, como en las plataformas asíncronas.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Todas as rodadas acontecem ao mesmo tempo e cada jogador as joga em paralelo, como nas plataformas assíncronas.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Tutti i round si giocano insieme e ogni giocatore li gioca in parallelo, come sulle piattaforme asincrone.")
	return /** @type {LocalizedString} */ ("All rounds run at once and each player plays them side by side, as on async platforms.")
});